define([
    'santa-components',
    'lodash',
    'dialogs/utils/dialogCustomCss',
    'prop-types',
    'componentsCore'
], function (
    santaComponents,
    _,
    getCustomCompCss,
    PropTypes,
    componentsCore
) {
    'use strict';

    const captchaDialog = {
        displayName: 'CaptchaDialog',
        mixins: [
            componentsCore.mixins.customSkinBasedComp({customCssFunc: getCustomCompCss}),
            componentsCore.mixins.postMessageCompMixin,
            componentsCore.mixins.cyclicTabbingMixin,
            componentsCore.mixins.createChildComponentMixin
        ],

        propTypes: {
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView.isRequired,
            language: PropTypes.string,
            onVerified: PropTypes.func,
            onClose: PropTypes.func,
            translations: PropTypes.object
        },

        getInitialState() {
            return {
                $view: this.props.isMobileView ? 'mobile' : 'desktop'
            };
        },

        createCaptcha() {
            const Captcha = this.createChildComponent(
                {},
                'wixui.Captcha',
                {skin: 'wixui.skins.Captcha', styleId: 'b1'},
                {
                    skinPart: 'wixui.skins.Captcha',
                    styleId: 'b1',
                    compProp: {
                        theme: 'light',
                        size: 'normal',
                        type: 'CaptchaProperties',
                        captchaType: 'image',
                        required: true,
                        viewerHandler: ({token}) => {
                            this.props.onVerified(token);
                        }
                    },
                    // Mocking this method to workaround wix-ui-santa components requirements
                    setRuntimeCompData: () => {},
                    style: {position: 'relative', height: '100%', width: '100%'},
                    scale: 0.5
                }
            );
            return Captcha;
        },

        getTranslation(key, fallback) {
            if (!this.props.translations) {
                return '';
            }

            return this.props.translations[key] || fallback;
        },

        getSkinProperties() {
            const titleText = this.getTranslation('recaptcha_popup_title', 'Verification');
            const subtitleText = this.getTranslation('recaptcha_popup_subtitle', 'Please confirm you\'re human.');
            const closeButton = this.getTranslation('recaptcha_popup_ariaLabel_closeButton', 'Close');
            const dialogText = this.getTranslation('recaptcha_popup_ariaLabel_topLevel', 'reCAPTCHA');

            const skin = {
                'dialog': {
                    role: 'dialog',
                    'aria-modal': true,
                    'aria-label': dialogText,
                    'aria-describedby': subtitleText,
                    tabIndex: -1
                },
                'xButton': {
                    'onClick': this.props.onClose,
                    'aria-label': closeButton
                },
                'title': {
                    children: titleText
                },
                'subtitle': {
                    children: subtitleText
                },
                'captchaWrapper': {
                    children: this.createCaptcha()
                }
            };

            return skin;
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.dialogs.CaptchaDialog', captchaDialog);

    return captchaDialog;
});
